import { render, staticRenderFns } from "./CoursewareTalkBubble.vue?vue&type=template&id=07a00faf&"
import script from "./CoursewareTalkBubble.vue?vue&type=script&lang=js&"
export * from "./CoursewareTalkBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a00faf')) {
      api.createRecord('07a00faf', component.options)
    } else {
      api.reload('07a00faf', component.options)
    }
    module.hot.accept("./CoursewareTalkBubble.vue?vue&type=template&id=07a00faf&", function () {
      api.rerender('07a00faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareTalkBubble.vue"
export default component.exports